'use client'

import ImageWithFallback from '@/components/common/image-with-fallback'
import MenuDotsIcon from '@/components/icons/menu-dots'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { TableCell } from '@/components/ui/table'
import { urlSafeProfilePath } from '@/helpers/url-safe-profile-path'
import { getUserProfilePictureUrl } from '@/helpers/user'
import dayjs from '@/lib/dayjs'
import { getDriverDisplayIdentifierDisplay } from '@/lib/driver-display-identifiers'
import Link from 'next/link'
import { Fragment } from 'react'

export default function OverviewDriverTableRowDesktop({
  attendee,
  setValue,
  showTeams,
  showCarClasses,
  showSplits,
  isManagerSide,
}) {
  return (
    <>
      <TableCell className="whitespace-normal break-all">
        <div className="flex items-center gap-2 text-nowrap py-2 pr-4">
          <div className="relative flex aspect-square h-10 w-10 overflow-hidden rounded-full">
            <ImageWithFallback
              src={getUserProfilePictureUrl(attendee.user, {
                profile: 'driver',
              })}
              alt="User Image"
              fill
            />
          </div>
          {getDriverDisplayIdentifierDisplay(attendee, 'nickname')}
        </div>
      </TableCell>

      {isManagerSide && (
        <Fragment>
          <TableCell>{dayjs(attendee.createTs).fromNow()}</TableCell>
          <TableCell className="capitalize">
            {attendee.role || 'driver'}
          </TableCell>
        </Fragment>
      )}

      {showTeams && <TableCell>{attendee.team?.name ?? '-'}</TableCell>}

      {showCarClasses && (
        <TableCell>{attendee.carClass?.name ?? '-'}</TableCell>
      )}

      {showSplits && <TableCell>{attendee.split?.name ?? '-'}</TableCell>}

      <TableCell>
        <div className="mr-2 flex justify-end gap-2">
          <Button variant="outline" asChild>
            <Link
              href={urlSafeProfilePath({
                ...attendee.user,
                id: attendee.userId,
                profileType: 'driver',
              })}
              target="_blank"
            >
              View Profile
            </Link>
          </Button>

          {isManagerSide && (
            <DropdownMenu modal={false}>
              <DropdownMenuTrigger asChild>
                <Button variant="outline" className="p-0! h-[45px] w-14">
                  <MenuDotsIcon className="h-full w-6 fill-shades-0" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-40">
                <DropdownMenuItem
                  className="cursor-pointer hover:bg-slate-200"
                  onClick={() => {
                    setValue('selectedAttendee', attendee)
                    setValue('selectedReason', 'ban')
                    document.body.style.pointerEvents = 'unset !important'
                  }}
                >
                  Ban member
                </DropdownMenuItem>

                <DropdownMenuItem
                  className="cursor-pointer hover:bg-slate-200"
                  onClick={() => {
                    setValue('selectedAttendee', attendee)
                    setValue('selectedReason', 'kick')
                    document.body.style.pointerEvents = 'unset !important'
                  }}
                >
                  Kick member
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </TableCell>
    </>
  )
}
